<template>
    <div class="red-button">
        {{ title }}
    </div>
</template>
<script>
    export default {
        name: 'RedButton',
        props: {
            title: {
                type: String,
                default:''
            },
        },
    }
</script>
<style lang="scss" scoped>
    .red-button{
        width: 100%;
        height: 40px;
        background: #F84025;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius:3px;
        color: #fff;
        font-size: 15px;
    }
</style>
